import React from 'react'
import Svg from './Svg'
export const SvgValidationError = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M0 0v24L24 0H0zm7.908 3.295l-.439 5.989H5.88l-.452-5.989h2.48zm-1.247 9.14c-.768 0-1.302-.41-1.302-1.164 0-.74.534-1.151 1.302-1.151.767 0 1.288.411 1.288 1.151 0 .753-.521 1.164-1.288 1.164z" />
  </Svg>
))
SvgValidationError.isIcon = true
export default SvgValidationError
